export enum Units {
  lb = 'lb',
  oz = 'oz',
  kg = 'kg',
  ton = 'ton',
  t = 't',
}
